import { useCustomerDetails } from '@egw/api'
import { Field, ModalDrawer } from '@egw/components'
import { useTranslation } from '@egw/i18n'
import { type FC, useState } from 'react'
import UpdateAddress from '../update-address/updated-address'

export const EditAddressField: FC = () => {
  const { t } = useTranslation('features-settings')
  const [openEdit, setOpenEdit] = useState<boolean>(false)
  const [modalTitle, setModalTitle] = useState<string>(t('update_address.CHANGE_ADDRESS.modal_title'))
  const { data } = useCustomerDetails()

  const address = data?.customer.address

  const formattedAddress = (() => {
    if (!address) {
      return null
    }

    return `${
      address.line1 + (address.line2 ? ` ${address.line2}, ` : ', ')
    }${address.city}, ${address.region} ${address.postalCode}`
  })()

  return formattedAddress ? (
    <>
      <Field
        valueClassName="font-light"
        className="w-full justify-between border-list mb-0 py-4 px-2"
        onEdit={() => {
          setOpenEdit(true)
        }}
        value={formattedAddress}
        isPII
      />
      <ModalDrawer
        title={modalTitle}
        isOpen={openEdit}
        onClose={() => {
          setOpenEdit(false)
        }}
      >
        <UpdateAddress
          onClose={() => {
            setOpenEdit(false)
          }}
          updateModalTitle={setModalTitle}
        />
      </ModalDrawer>
    </>
  ) : null
}
